import { PLAN_COLLAPSE_DISABLED } from '../../../data/projects/timeline/agent-todo/collapsePlanSteps';
import { PlanStepsPanel } from '../timeline/agent-todo/PlanStepsPanel';
import type { ComputerUsePlanPhase } from './ComputerUsePlanCard.utils';

import type { JSX } from 'react';

export interface ComputerUsePlanChecklistProps {
  steps: readonly string[] | undefined;
  phase: ComputerUsePlanPhase;
}

export const ComputerUsePlanChecklist = ({
  steps,
  phase,
}: ComputerUsePlanChecklistProps): JSX.Element | null => {
  if (!steps?.length) return null;

  // The backend exposes no active step, so do not invent intermediate progress.
  const status = phase === 'done' ? 'completed' : 'pending';
  return (
    <div data-testid="computer-use-plan-checklist">
      <PlanStepsPanel
        items={steps.map((title, index) => ({ id: index, title, status }))}
        collapseAfter={PLAN_COLLAPSE_DISABLED}
      />
    </div>
  );
};
